import * as ACTION_TYPES from './constants';

import { Setting } from '../../../Api';

import { Toast } from '../../Common';

const Api = Setting.Scholar;

const reducer = 'SettingScholarReducer';

export default class SettingScholarActions {
    static loading_index = toggle => ({
        type: ACTION_TYPES.SETTING_SCHOLAR_LOADING_INDEX,
        toggle,
    });

    static loading_show = toggle => ({
        type: ACTION_TYPES.SETTING_SCHOLAR_LOADING_SHOW,
        toggle,
    });

    static search =
        (search = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: ACTION_TYPES.SETTING_SCHOLAR_SEARCH, search });
        };

    static requests = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_index(true));
            const query = getState()[reducer].get('search');
            const res = await Api.index(query);
            if (res instanceof Error) throw res;
            dispatch(this.index(res));
        } catch (error) {
            dispatch(this.loading_index(false));
        } finally {
        }
    };

    static index = (scholars = []) => ({
        type: ACTION_TYPES.SETTING_SCHOLAR_INDEX,
        scholars,
    });

    static request = params => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.show(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const body = getState()[reducer].get('scholar');
            const res = await Api.create(body);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已保存');
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static destroy = body => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.remove(body);
            if (res instanceof Error) throw res;
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static exclude = body => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.exclude(body);
            if (res instanceof Error) throw res;
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static project = body => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.project(body);
            if (res instanceof Error) throw res;
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static show = (scholar = {}) => ({
        type: ACTION_TYPES.SETTING_SCHOLAR_SHOW,
        scholar,
    });

    static reset = () => ({
        type: ACTION_TYPES.SETTING_SCHOLAR_RESET,
    });

    static column = (columns = []) => ({
        type: ACTION_TYPES.SETTING_SCHOLAR_COLUMN,
        columns,
    });

    static options = () => async (dispatch, getState) => {
        try {
            const res = await Api.options();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.SETTING_SCHOLAR_OPTION,
                options: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    static school = () => async (dispatch, getState) => {
        try {
            const res = await Api.school();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.SETTING_SCHOLAR_SCHOOL,
                schools: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };
}
